export * from './checkout.module';

export { CheckoutComponent } from './components/checkout.component';



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/checkout/index.ts